document.addEventListener('DOMContentLoaded', () => {
  setupMobileNav();
  setupFAQ();
  setupAjaxAddToCart();
  setupCartInteractions();
  setupDemoCheckout();
});

function setupMobileNav() {
  const navToggle = document.querySelector('.nav-toggle');
  const siteNav = document.querySelector('.site-nav');
  if (!navToggle || !siteNav) return;

  const closeMenu = () => {
    navToggle.classList.remove('active');
    navToggle.setAttribute('aria-expanded', 'false');
    siteNav.classList.remove('open');
  };

  navToggle.addEventListener('click', () => {
    const isOpen = siteNav.classList.toggle('open');
    navToggle.classList.toggle('active', isOpen);
    navToggle.setAttribute('aria-expanded', String(isOpen));
  });

  siteNav.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => {
      if (window.innerWidth <= 680) closeMenu();
    });
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 680) closeMenu();
  });
}

function setupFAQ() {
  document.querySelectorAll('.faq-question').forEach((question) => {
    question.addEventListener('click', () => {
      const item = question.closest('.faq-item');
      const answer = item?.querySelector('.faq-answer');
      if (!item || !answer) return;

      const isOpen = item.classList.contains('open');
      item.classList.toggle('open', !isOpen);
      question.setAttribute('aria-expanded', String(!isOpen));
      answer.style.maxHeight = !isOpen ? `${answer.scrollHeight}px` : '0px';
    });
  });
}

async function refreshCartCount() {
  try {
    const response = await fetch(`${window.themeRoutes.cart}.js`, {
      headers: { Accept: 'application/json' }
    });
    const cart = await response.json();
    document.querySelectorAll('[data-cart-count]').forEach((node) => {
      node.textContent = cart.item_count;
    });
  } catch (error) {
    console.error('Unable to refresh cart count', error);
  }
}

function setupAjaxAddToCart() {
  document.querySelectorAll('[data-ajax-add-to-cart]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      if (!button) return;

      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding...';

      try {
        const response = await fetch(`${window.themeRoutes.cartAdd}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });

        if (!response.ok) throw new Error('Add to cart failed');

        await refreshCartCount();
        button.textContent = 'Added to Cart ✓';
      } catch (error) {
        console.error(error);
        button.textContent = 'Try Again';
      }

      setTimeout(() => {
        button.disabled = false;
        button.textContent = originalText;
      }, 1200);
    });
  });
}

function setupCartInteractions() {
  const cartContainer = document.querySelector('[data-cart-items]');
  if (!cartContainer) return;

  cartContainer.addEventListener('click', async (event) => {
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;

    const button = target.closest('[data-cart-action]');
    if (!(button instanceof HTMLElement)) return;

    const action = button.dataset.cartAction;
    const key = button.dataset.key;
    const input = cartContainer.querySelector(`[data-quantity-input][data-key="${key}"]`);
    if (!(input instanceof HTMLInputElement) || !key) return;

    const current = parseInt(input.value || '1', 10);
    let nextQuantity = current;

    if (action === 'increase') nextQuantity = current + 1;
    if (action === 'decrease') nextQuantity = Math.max(0, current - 1);
    if (action === 'remove') nextQuantity = 0;

    await updateCartItem(key, nextQuantity);
  });

  cartContainer.addEventListener('change', async (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement) || !target.matches('[data-quantity-input]')) return;

    const key = target.dataset.key;
    const quantity = Math.max(1, parseInt(target.value || '1', 10));
    if (!key) return;

    await updateCartItem(key, quantity);
  });
}

async function updateCartItem(key, quantity) {
  try {
    const response = await fetch(`${window.themeRoutes.cartChange}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: key, quantity })
    });

    if (!response.ok) throw new Error('Cart update failed');
    window.location.reload();
  } catch (error) {
    console.error(error);
    window.alert('Unable to update cart right now. Please try again.');
  }
}

function setupDemoCheckout() {
  document.querySelectorAll('[data-demo-checkout]').forEach((button) => {
    button.addEventListener('click', () => {
      window.alert('Demo Store – Payments Not Available');
    });
  });
}
